import React, { useState, useEffect, useRef, useMemo } from "react";
import useApi from "../hooks/useApi";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Ratio from "react-bootstrap/Ratio";

const FileWidget = (props) => {
  const { value } = useMemo(() => props, [props]);
  const { multiple = true } = props;

  const [previewFiles, setPreviewFiles] = useState(value);
  const [show, setShow] = useState(false);
  const [showSnapped, setShowSnapped] = useState(false);
  const [filename, setFilename] = useState("");
  const [columnError, setColumnError] = useState();
  const [multileFiles, setMultipleFiles] = useState(multiple);
  const [showFileInput, setShowFileInput] = useState(true);

  const videoRef = useRef();
  const cavasRef = useRef();
  const filenameInputRef = useRef();

  // const [streamObj, setStreamObj] = useState();

  const handleClose = async () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);

  let preview = [];

  const preparePreview = (e) => {
    const files = e.target.files;

    for (const file of files) {
      if (props?.destination) {
        file.destination = props?.destination;
      }
      file.local = 1;
      preview.push(file);
    }

    setPreviewFiles([...previewFiles, ...preview]);
  };

  const removeFile = (fileIndex) => {
    setPreviewFiles([
      ...previewFiles.filter((file, index) => {
        return index != fileIndex;
      }),
    ]);
  };

  const markRemove = (fileIndex) => {
    const removed = previewFiles;
    removed[fileIndex].delete = 1;

    setPreviewFiles([...removed]);
  };

  const takePicture = async () => {
    setShowSnapped(false);
    handleShow();
    let stream = await navigator.mediaDevices.getUserMedia({
      video: { width: { ideal: 1280 }, height: { ideal: 720 } },
      audio: false,
    });

    videoRef.current.srcObject = stream;
  };

  const snapPicture = () => {
    try {
      cavasRef.current.width = videoRef.current.videoWidth;
      cavasRef.current.height = videoRef.current.videoHeight;

      setShowSnapped(true);
      cavasRef.current
        .getContext("2d")
        .drawImage(
          videoRef.current,
          0,
          0,
          videoRef.current.videoWidth,
          videoRef.current.videoHeight
        );

      filenameInputRef.current.focus();
    } catch (error) {
      console.error(error);
    }
  };

  const reSnapPicture = () => {
    setShowSnapped(false);
    setFilename("");
  };

  const savePicture = () => {
    try {
      if (!filename) {
        setColumnError("Please enter filename");
        filenameInputRef.current.focus();
      } else {
        cavasRef.current.toBlob((blob) => {
          const file = new File([blob], `${filename.replace(" ", "_")}.png`, {
            type: "image/png",
          });

          file.local = 1;
          setPreviewFiles((pfiles) => [...pfiles, ...[file]]);
          reSnapPicture();
        }, "image/png");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    props?.onChange(previewFiles);

    if (multileFiles) {
      setShowFileInput(true);
    } else {
      if (previewFiles?.length >= 1) {
        setShowFileInput(false);
      } else {
        setShowFileInput(true);
      }
    }
  }, [previewFiles]);

  return (
    <div>
      <div className="d-flex">
        {showFileInput && (
          <>
            <div className="p-1 w-100">
              <input
                className="inputfile"
                id={props?.id}
                type="file"
                multiple
                onChange={preparePreview}
              />
              <label
                htmlFor={props?.id}
                className="btn btn-outline-light rounded px-3 fs-5 m-0"
              >
                {previewFiles?.length > 0 &&
                previewFiles?.filter((file) => !file.delete == 1)?.length > 0
                  ? "Add files"
                  : "Choose Files"}
              </label>
            </div>
            <Button variant="primary" onClick={takePicture}>
              <i className="bi bi-camera-fill fs-4" />
            </Button>

            <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Take Picture</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className={(!showSnapped && "d-none") || "false"}>
                  <Form autoComplete="off">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>File Name</Form.Label>
                      <Form.Control
                        type="text"
                        size="lg"
                        name="filename"
                        className="border-primary"
                        ref={filenameInputRef}
                        onChange={(e) => setFilename(e.target.value)}
                        value={filename}
                      />
                      <Form.Text className="text-danger">
                        {columnError}
                      </Form.Text>
                    </Form.Group>
                  </Form>
                  <Ratio aspectRatio={"16x9"}>
                    <canvas ref={cavasRef} className={" w-100"}></canvas>
                  </Ratio>
                </div>
                <Ratio aspectRatio={"16x9"} className={showSnapped && "d-none"}>
                  <video id="video" ref={videoRef} className={"w-100"} autoPlay>
                    Loading ...
                  </video>
                </Ratio>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>
                {showSnapped ? (
                  <>
                    <Button variant="primary" onClick={reSnapPicture}>
                      <i className="bi bi-camera-fill me-2" />
                      Retake
                    </Button>
                    <Button variant="primary" onClick={savePicture}>
                      <i className="bi bi-plus me-2" />
                      Add
                    </Button>
                  </>
                ) : (
                  <Button variant="primary" onClick={snapPicture}>
                    <i className="bi bi-camera-fill me-2" />
                    Snap
                  </Button>
                )}
              </Modal.Footer>
            </Modal>
          </>
        )}
      </div>
      {previewFiles?.length > 0 &&
        previewFiles?.filter((file) => !file.delete == 1)?.length > 0 && (
          <div
            className="w100 border mt-2 rounded"
            style={{
              height: "15rem",
              overflow: "auto",
            }}
          >
            <Table responsive striped bordered hover>
              <tbody>
                {previewFiles.map(
                  (file, index) =>
                    !file?.delete == 1 && (
                      <tr key={index}>
                        <td>
                          <div className="d-flex">
                            {file.local ? (
                              <>
                                <div className="p-1 w-100">
                                  {file?.type?.split("/").includes("image") && (
                                    <Image
                                      thumbnail
                                      src={URL.createObjectURL(file)}
                                      style={{ width: 120 }}
                                    />
                                  )}
                                  <p>{file.name}</p>
                                </div>

                                <div className="p-1 flex-shrink-1">
                                  <Button
                                    variant="outline-danger"
                                    onClick={() => removeFile(index)}
                                  >
                                    <i className="bi bi-trash" />
                                  </Button>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="p-1 w-100">
                                  {file?.mimetype
                                    .split("/")
                                    .includes("image") && (
                                    <Image
                                      thumbnail
                                      src={file.path}
                                      style={{ width: 120 }}
                                    />
                                  )}
                                  <p>{file.originalname}</p>
                                </div>

                                <div className="p-1 flex-shrink-1">
                                  <Button
                                    variant="outline-danger"
                                    onClick={() => markRemove(index)}
                                  >
                                    <i className="bi bi-trash" />
                                  </Button>
                                </div>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </Table>
          </div>
        )}
    </div>
  );
};

export default FileWidget;
